import(/* webpackMode: "eager" */ "/home/interim/frontend/app/contacts/page.tsx");
